module.exports = __webpack_public_path__ + "img/texiao-_0000s_0005_6.6fc3db06.png";